module.exports = __webpack_public_path__ + "static/media/perfectModal.1b60e3e9.jpg";